var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-navigation-drawer",
        {
          staticClass: "pt-8",
          attrs: {
            "mobile-breakpoint": "660",
            app: "",
            clipped: "",
            width: "400",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "px-4", attrs: { flat: "" } },
            [
              _c(
                "v-card",
                { staticClass: "mb-4", attrs: { flat: "" } },
                [
                  _c("p", { staticClass: "mb-1 text-subtitle-2" }, [
                    _vm._v("Case"),
                  ]),
                  _c("InputSelectCase", {
                    attrs: { "browse-btn-small": "", "disable-url-input": "" },
                    model: {
                      value: _vm.caseId,
                      callback: function ($$v) {
                        _vm.caseId = $$v
                      },
                      expression: "caseId",
                    },
                  }),
                  _vm.caseId
                    ? [
                        _vm.loadingOutputs.progress > 0
                          ? [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    { staticClass: "py-0" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.loadingOutputs.text) +
                                          " "
                                      ),
                                      _c("v-progress-linear", {
                                        attrs: {
                                          value: _vm.loadingOutputs.progress,
                                          color: "primary",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _vm.caseObj && _vm.sqlSSEOutput.length
            ? [
                _c(
                  "v-card",
                  { staticClass: "pa-4", attrs: { flat: "" } },
                  [
                    _c("p", { staticClass: "mb-1 text-subtitle-2" }, [
                      _vm._v("Settings"),
                    ]),
                    _vm._l(_vm.sections, function (section) {
                      return _c("v-switch", {
                        key: section.key,
                        attrs: {
                          dense: "",
                          "hide-details": "",
                          label: section.title,
                          disabled: !section.available,
                          "append-icon": section.editable ? "mdi-pencil" : "",
                        },
                        on: {
                          "click:append": function ($event) {
                            return _vm.openSettings(section.key)
                          },
                        },
                        model: {
                          value: section.enabled,
                          callback: function ($$v) {
                            _vm.$set(section, "enabled", $$v)
                          },
                          expression: "section.enabled",
                        },
                      })
                    }),
                  ],
                  2
                ),
              ]
            : _vm._e(),
          _c(
            "v-card",
            { staticClass: "pa-4", attrs: { flat: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    outlined: "",
                    color: "primary",
                    block: "",
                    rounded: "",
                    loading: _vm.pdfDownloadProgress.value > 0,
                  },
                  on: { click: _vm.downloadReport },
                  scopedSlots: _vm._u([
                    {
                      key: "loader",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "custom-loader text-capitalize" },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.pdfDownloadProgress.text) + " "
                              ),
                              _c("v-progress-linear", {
                                attrs: { value: _vm.pdfDownloadProgress.value },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("v-icon", { staticClass: "mr-2" }, [
                    _vm._v("mdi-download"),
                  ]),
                  _vm._v(" download report "),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "v-container",
        [
          _c(
            "v-card",
            { attrs: { tile: "" } },
            [
              _c(
                "v-responsive",
                { attrs: { "aspect-ratio": 1 / Math.sqrt(2) } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "d-flex justify-center",
                      attrs: { tile: "", flat: "" },
                    },
                    [
                      _c("vue-html2pdf", {
                        ref: "html2Pdf",
                        attrs: {
                          "show-layout": true,
                          "float-layout": false,
                          "enable-download": true,
                          "preview-modal": false,
                          "paginate-elements-by-height": 1400,
                          filename: _vm.currentTemplate,
                          "pdf-quality": 2,
                          "manual-pagination": false,
                          "pdf-format": "a4",
                          "pdf-content-width": "800px",
                          "html-to-pdf-options": _vm.pdfOptions,
                        },
                        on: {
                          progress: function ($event) {
                            return _vm.onProgress($event)
                          },
                          beforeDownload: function ($event) {
                            return _vm.beforeDownload($event)
                          },
                          hasStartedGeneration: function ($event) {
                            return _vm.hasStartedGeneration()
                          },
                          hasGenerated: function ($event) {
                            return _vm.hasGenerated($event)
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "pdf-content",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "v-application" }, [
                                  _c(
                                    "div",
                                    { staticClass: "pdf-content" },
                                    [
                                      _c(
                                        "v-card",
                                        { attrs: { flat: "" } },
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "d-flex justify-space-between align-end",
                                              attrs: { flat: "" },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  height: "48",
                                                  src: require("@/assets/rex-logo.png"),
                                                },
                                              }),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-subtitle-1 mb-0",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.currentDate)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-card",
                                            {
                                              attrs: { tile: "", outlined: "" },
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "mb-0 pl-1" },
                                                [
                                                  _c("strong", [
                                                    _vm._v("Case:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.caseName) +
                                                      " / "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v("Solve date:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.solveDate) +
                                                      " / "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v("Market:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.market) +
                                                      " / "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v("Project:"),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.projectName) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.showItem("description")
                                        ? _c(
                                            "section",
                                            { staticClass: "pdf-item" },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "section-title",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Project Description"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    {
                                                      attrs: {
                                                        "no-gutters": "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        { attrs: { sm: "8" } },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "section-paragraph",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.description
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        { attrs: { sm: "4" } },
                                                        [
                                                          _c(
                                                            "v-card",
                                                            {
                                                              staticClass:
                                                                "mb-2 pt-2",
                                                              attrs: {
                                                                flat: "",
                                                                outlined: "",
                                                                height: "200",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "ProjectDiagram",
                                                                {
                                                                  attrs: {
                                                                    network:
                                                                      _vm.diagramNetwork,
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.showItem("projectTable")
                                        ? _c(
                                            "section",
                                            { staticClass: "pdf-item" },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "section-title",
                                                    },
                                                    [_vm._v("Project Table")]
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass:
                                                        "justify-center",
                                                      attrs: {
                                                        "no-gutters": "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        { attrs: { sm: "5" } },
                                                        [
                                                          _c("TableSimple", {
                                                            attrs: {
                                                              data: _vm
                                                                .projectTable
                                                                .tables,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _vm.projectTable.charts
                                                        .length
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                sm: "7",
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.projectTable
                                                                .charts,
                                                              function (
                                                                chart,
                                                                i
                                                              ) {
                                                                return _c(
                                                                  "Plotly",
                                                                  {
                                                                    key:
                                                                      "chart-projectTable-" +
                                                                      i,
                                                                    attrs: {
                                                                      layout:
                                                                        chart.layout,
                                                                      data: chart.data,
                                                                      "display-mode-bar": false,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.showItem(
                                        "financialInputAssumptionsStorageServices"
                                      )
                                        ? _c(
                                            "section",
                                            { staticClass: "pdf-item" },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "section-title",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.getTitle(
                                                              "financialInputAssumptionsStorageServices"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass:
                                                        "justify-center",
                                                    },
                                                    [
                                                      _vm
                                                        .financialInputAssumptionsStorageServices
                                                        .financialTable
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                sm: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "TableSimple",
                                                                {
                                                                  attrs: {
                                                                    data: _vm
                                                                      .financialInputAssumptionsTable
                                                                      .financialTable,
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "v-col",
                                                        { attrs: { sm: "6" } },
                                                        [
                                                          _c("TableSimple", {
                                                            attrs: {
                                                              data: _vm
                                                                .financialInputAssumptionsStorageServices
                                                                .energyStorageServices,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.showItem("systemDispatch")
                                        ? _c(
                                            "section",
                                            { staticClass: "pdf-item" },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "section-title",
                                                    },
                                                    [_vm._v("System Dispatch")]
                                                  ),
                                                  _vm._l(
                                                    _vm.systemDispatch.charts,
                                                    function (chart, i) {
                                                      return _c("Plotly", {
                                                        key:
                                                          "chart-projectTable-" +
                                                          i,
                                                        attrs: {
                                                          layout: chart.layout,
                                                          data: chart.data,
                                                          "display-mode-bar": false,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass:
                                                        "justify-space-around",
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("TableSimple", {
                                                            attrs: {
                                                              data: _vm
                                                                .systemDispatch
                                                                .tables,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                2
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.showItem("energyPrices")
                                        ? _c(
                                            "section",
                                            { staticClass: "pdf-item" },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "section-title",
                                                    },
                                                    [_vm._v("Energy Prices")]
                                                  ),
                                                  _c("SectionEnergyPrices", {
                                                    attrs: {
                                                      "case-obj": _vm.caseObj,
                                                      settings:
                                                        _vm.getSectionConfig(
                                                          "energyPrices"
                                                        ).settings,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.showItem("annualOutputs")
                                        ? _c(
                                            "section",
                                            { staticClass: "pdf-item" },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "section-title",
                                                    },
                                                    [_vm._v("Annual Outputs")]
                                                  ),
                                                  _c("TableSimple", {
                                                    attrs: {
                                                      data: _vm.annualOutputs
                                                        .tables,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "600" },
          model: {
            value: _vm.sectionSettingsDialog.dialog,
            callback: function ($$v) {
              _vm.$set(_vm.sectionSettingsDialog, "dialog", $$v)
            },
            expression: "sectionSettingsDialog.dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(_vm.sectionSettingsDialog.component, {
                key: _vm.sectionSettingsDialog.key,
                tag: "component",
                model: {
                  value: _vm.sectionSettingsDialog.settings,
                  callback: function ($$v) {
                    _vm.$set(_vm.sectionSettingsDialog, "settings", $$v)
                  },
                  expression: "sectionSettingsDialog.settings",
                },
              }),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveSettingsDialog(
                            _vm.sectionSettingsDialog.key
                          )
                        },
                      },
                    },
                    [_vm._v(" save ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }